export default (function (zipCode) {
  return /^\d{5}$/.test(zipCode);
});